import { useEffect, useRef } from "react";

export default function usePrevious<Type>(value: Type) {
  const ref = useRef<Type>(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
